import React, { useMemo } from 'react';
import ReactECharts from 'echarts-for-react';

const HIT_COLORS = {
  'Home Run': '#c4333e',
  'Triple':   '#d8ceb3',
  'Double':   '#a9c9b1',
  'Single':   '#658d71',
};

const HitTypeChart = ({ hits, awayAbbr, homeAbbr }) => {
  const option = useMemo(() => {
    const types = ['Single', 'Double', 'Triple', 'Home Run'];
    const awayData = types.map(t => hits.filter(h => h.isTop && h.event === t).length);
    const homeData = types.map(t => hits.filter(h => !h.isTop && h.event === t).length);

    return {
      backgroundColor: 'transparent',
      grid: { top: 20, right: 16, bottom: 40, left: 44 },
      legend: {
        bottom: 0,
        textStyle: { color: '#a9c9b1', fontSize: 9 },
        itemWidth: 10, itemHeight: 8,
      },
      tooltip: {
        trigger: 'axis',
        backgroundColor: '#1e3a29',
        borderColor: '#658d71',
        textStyle: { color: '#d8ceb3', fontSize: 10 },
      },
      xAxis: {
        type: 'category',
        data: types,
        axisLabel: { color: '#a9c9b1', fontSize: 9 },
        axisLine: { lineStyle: { color: '#658d71' } },
      },
      yAxis: {
        type: 'value',
        minInterval: 1,
        axisLabel: { color: '#a9c9b1', fontSize: 9 },
        axisLine: { lineStyle: { color: '#658d71' } },
        splitLine: { lineStyle: { color: 'rgba(101,141,113,0.2)' } },
      },
      series: [
        {
          name: awayAbbr,
          type: 'bar',
          data: awayData,
          itemStyle: { color: 'rgba(169,201,177,0.8)', borderColor: '#a9c9b1', borderWidth: 1 },
          barGap: '10%',
        },
        {
          name: homeAbbr,
          type: 'bar',
          data: homeData,
          itemStyle: { color: 'rgba(196,51,62,0.75)', borderColor: '#c4333e', borderWidth: 1 },
        },
      ],
    };
  }, [hits, awayAbbr, homeAbbr]);

  return <ReactECharts option={option} style={{ height: '160px' }} />;
};

export default HitTypeChart;